import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { DialogTitle, Button, Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import { MdArrowBack, MdArrowRight, MdHelp, MdLock, MdPerson } from "react-icons/md";
import { select } from "slate";
import ResearcherEditProfile from "../components/ResearcherEditProfile";
import ResearcherChangePassword from "../components/ResearcherChangePassword";
import { web_url } from "../../constant";
import ResearcherTerms from "../components/ResearcherTerms";
import ResearcherHelp from "../components/ResearcherHelp";
import { LucideKey } from "lucide-react";

const url = "http://localhost:8080/api/";
function ResearcherSettingsPageDesktop() {

    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [open2, setOpen2] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const [personDetails, setPersonDetails] = useState({
        userName: "",
        mobile: "",
        email: "",
    }
    )

    const [isLoading, setIsLoading] = useState(false);

    const [openError, setOpenError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setErrorMsg(t('t93'));
        } else {
            setErrorMsg(t('t94'));
        }
        setIsLoading(false);
        setOpenError(true);
    };

    useEffect(() => {
        localStorage.removeItem('studentEmailForResetPassword');
    }, []);

    const handleCloseError = () => {
        setOpenError(false);
    };

    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setIsLoading(true)

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            const apiUrl = `${web_url}/api/auth/researchers/${logDetails.email}`
            axios.get(apiUrl, configToken)
                .then((response) => {
                    console.log('data retrieved successfully');
                    // const [grade, section] = (response.data.assignedClass).split("-");
                    setPersonDetails({
                        userName: response.data.userFullName,
                        mobile: response.data.contactNumber,
                        email: response.data.userEmail,
                    })
                    localStorage.setItem('name', response.data.userFullName);
                    localStorage.setItem('mobile', response.data.contactNumber);
                    setIsLoading(false);
                })
                .catch((err) => {
                    console.log("error occured");
                    handleClickOpenError("error occured")
                });
        }
    }, [])

    // const handleDeleteAccount = () => {
    //     setIsLoading(true);
    //     // const apiUrl1 = `${url}auth/researchers/${personDetails.email}`;
    //     axios.delete(`${web_url}/api/auth/researchers/${personDetails.email}`)
    //         .then((response) => {
    //             localStorage.removeItem('logDetails');
    //             sessionStorage.removeItem('logDetails');
    //             setIsLoading(false);
    //             navigate('/loginas')
    //         })
    //         .catch((err) => {
    //             if (err.response) {
    //                 // console.log(err.response)
    //                 if (err.response.data.error) {
    //                     handleClickOpenError(err.response.data.error);
    //                 } else if (err.response.data.message) {
    //                     handleClickOpenError(err.response.data.message);
    //                 } if (err.response.data.token) {
    //                     handleClickOpenError(err.response.data.token);
    //                 } else {
    //                     handleClickOpenError("An unknown error occured");
    //                 }

    //             }
    //             setIsLoading(false);
    //         })
    // }

    const handleDeleteAccount = () => {
        setIsLoading(true);

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };

        const config = {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${logDetails.token}`,
            },
        };

        const filterDetails = {
            receiverEmail: personDetails.email,
            userRole: "RESEARCHER"
        }


        axios.post(`${web_url}/api/invitations/admin/filter`, filterDetails, config).then((resInv) => {
            console.log('res inv: ', resInv);

            if (resInv.data.length === 0) {
                axios.delete(`${web_url}/api/auth/researchers/${personDetails.email}`, configToken)
                    .then((response) => {
                        console.log('res inv: ', "done");
                        localStorage.clear();
                        sessionStorage.clear();
                        setIsLoading(false);
                        navigate('/loginas')
                    })
                    .catch((err1) => {
                        console.log(err1.response)
                        if (err1.response) {

                            if (err1.response.data.error) {
                                handleClickOpenError(err1.response.data.error);
                            } else if (err1.response.data.message) {
                                handleClickOpenError(err1.response.data.message);
                            } if (err1.response.data.token) {
                                handleClickOpenError(err1.response.data.token);
                            } else {
                                handleClickOpenError("An unknown error occured");
                            }

                        }
                        setIsLoading(false);
                    })
            } else {
                console.log('res inv: 2 ');
                axios.delete(`${web_url}/api/invitations/admin/${resInv.data[0].id}`, configToken).then((resDelInv) => {
                    axios.delete(`${web_url}/api/auth/researchers/${personDetails.email}`, configToken)
                        .then((response) => {
                            localStorage.clear();
                            sessionStorage.clear();
                            setIsLoading(false);
                            navigate('/loginas')
                        })
                        .catch((err) => {
                            if (err.response) {
                                // console.log(err.response)
                                if (err.response.data.error) {
                                    handleClickOpenError(err.response.data.error);
                                } else if (err.response.data.message) {
                                    handleClickOpenError(err.response.data.message);
                                } if (err.response.data.token) {
                                    handleClickOpenError(err.response.data.token);
                                } else {
                                    handleClickOpenError("An unknown error occured");
                                }

                            }
                            setIsLoading(false);
                        })
                }).catch((resDelErr) => {
                    setIsLoading(false);
                    if (resDelErr.response) {
                        // console.log(err.response)
                        if (resDelErr.response.data.error) {
                            handleClickOpenError(resDelErr.response.data.error);
                        } else if (resDelErr.response.data.message) {
                            handleClickOpenError(resDelErr.response.data.message);
                        } if (resDelErr.response.data.token) {
                            handleClickOpenError(resDelErr.response.data.token);
                        } else {
                            handleClickOpenError("An unknown error occured");
                        }

                    }
                })
            }

        }).catch((errInv) => {
            setIsLoading(false);
            if (errInv.response) {
                // console.log(err.response)
                if (errInv.response.data.error) {
                    handleClickOpenError(errInv.response.data.error);
                } else if (errInv.response.data.message) {
                    handleClickOpenError(errInv.response.data.message);
                } if (errInv.response.data.token) {
                    handleClickOpenError(errInv.response.data.token);
                } else {
                    handleClickOpenError("An unknown error occured");
                }

            }
        })
    }

    const [selectedPage, setSelectedPage] = useState(100);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 1270) {
                navigate('/mobile/researcher/settings')
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    useEffect(() => {

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const checkAuth = () => {
            const logDetails = getLogDetails();
            const currentTime = new Date();

            if (!logDetails) {
                alert("Please re-sign up to continue");
                localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            } else if (logDetails.category.toLowerCase() !== "researcher") {
                alert("Please re-sign up to continue");
                // localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            }

            if (sessionStorage.getItem('exp')) {
                if (new Date(sessionStorage.getItem('exp')) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                } else if (sessionStorage.getItem('exp') !== logDetails.exp) {
                    alert("Please re-sign up to continue");
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            } else {
                sessionStorage.setItem('exp', logDetails.exp);
                if (new Date(logDetails.exp) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            }
        };

        checkAuth(); // Run on mount

        const handleStorageChange = (event) => {
            if (event.key === "logDetails") {
                checkAuth(); // Re-check authentication if storage changes
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge bg-no-repeat bg-cover min-h-screen w-screen xl:pt-[50px]`}>

            <div className="rounded-md hidden xl:grid grid-cols-3 py-[5px] 2xl:py-[10px] bg-gradient-to-r from-[#FFA803] to-[#FFD12E] mx-[70px] px-[20px]">
                <div className="flex justify-start items-center">
                    <img className="h-[40px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px] font-semibold text-[20px]">{t('t1')}</p>
                </div>
                <div className="grid grid-cols-3 w-full">
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/home-b.svg" alt="home" onClick={() => navigate('/desktop/researcher/dashboard')} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t410')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/mail-b.svg" alt="mail" onClick={() => {
                            const mailRequest = {
                                type: 'new',
                                subject: 'nothing'
                            };
                            localStorage.setItem('threadId', JSON.stringify(mailRequest));
                            navigate('/desktop/researcher/mailbox')

                        }} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t411')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/settings-w.svg" alt="settings" onClick={() => navigate('/desktop/researcher/settings')} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t153')}
                        </span>
                    </div>
                </div>
                <div className="flex justify-end items-center">
                    <Menu as="div" className="text-left items-right">
                        <div>
                            <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                                {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                                <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                            </MenuButton>
                        </div>

                        <MenuItems
                            transition
                            className="absolute right-0 z-10 mt-2 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                            <div className="py-1">
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("English");
                                            changeLanguage('en')
                                        }}
                                    >
                                        English
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Sinhala");
                                            changeLanguage('si')
                                        }}
                                    >
                                        සිංහල
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Tamil");
                                            changeLanguage('ta')
                                        }}
                                    >
                                        தமிழ்
                                    </button>
                                </MenuItem>
                            </div>
                        </MenuItems>
                    </Menu>
                </div>
            </div>
            {
                isLoading ?
                    <div className="items-center justify-center flex pt-[30px]">
                        <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                    </div>
                    :

                    <div className="hidden xl:grid grid-cols-2 w-full">
                        <div>
                            <div className="">

                                <div className="flex flex-col items-center pt-[20px] xl:pt-[40px] 2xl:pt-[60px]">
                                    <div className="flex flex-col pt-[20px] justify-center items-center pt-[5px]">
                                        <p className="hidden xl:block font-bold text-[25px] md:text-[40px] lg:text-[50px] xl:text-[30px] text-black">{t('t153')}</p>
                                    </div>
                                </div>
                                <hr className=" border-gray-400 flex items-center mx-[30px] mt-[20px] xl:ml-[90px]" />
                                <div className="pt-[30px] xl:pl-[40px]">
                                    {/* <div className="flex w-full items-center justify-between mt-[10px]">
                                        <p className="text-black pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px] text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                            {t('t154')}
                                        </p>
                                        <MdArrowRight onClick={() => setSelectedPage(0)} size={30} className="cursor-pointer hidden xl:block mr-[30px] md:mr-[110px] lg:mr-[140px] xl:mr-[50px]" />
                                    </div>
                                    <div className="flex w-full items-center justify-between mt-[10px]">
                                        <p className="text-black pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px] text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                            {t('t155')}
                                        </p>
                                        <MdArrowRight onClick={() => setSelectedPage(1)} size={30} className="cursor-pointer mr-[30px] md:mr-[110px] lg:mr-[140px] xl:mr-[50px]" />
                                    </div>
                                    <div className="flex w-full items-center justify-between mt-[10px]">
                                        <p className="text-black pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px] text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                            {t('t156')}
                                        </p>
                                        <MdArrowRight onClick={() => setSelectedPage(2)} size={30} className="cursor-pointer mr-[30px] md:mr-[110px] lg:mr-[140px] xl:mr-[50px]" />
                                    </div>
                                    <div className="flex w-full items-center justify-between mt-[10px]">
                                        <p className="text-black pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px] text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                            {t('t157')}
                                        </p>
                                        <MdArrowRight onClick={() => setSelectedPage(3)} size={30} className="cursor-pointer mr-[30px] md:mr-[110px] lg:mr-[140px] xl:mr-[50px]" />
                                    </div> */}
                                    <div className=" flex w-full items-center justify-between mt-[10px] pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px]">
                                        <div className={`hover:bg-[#FCE7AE] hover:bg-opacity-50 cursor-pointer flex w-full items-center justify-between ${selectedPage === 0 ? 'bg-[#FCE7AE]' : ''} px-[10px] py-[5px] rounded-md`} onClick={() => setSelectedPage(0)}>
                                            <div className="flex items-center gap-[7px] ">
                                                <MdPerson />
                                                <p className="text-black text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                                    {t('t154')}
                                                </p>
                                            </div>
                                            <MdArrowRight size={30} className="hidden xl:block mr-[30px] md:mr-[110px] lg:mr-[140px] xl:mr-[50px] cursor-pointer" />
                                        </div>
                                    </div>
                                    <div className=" flex w-full items-center justify-between mt-[10px] pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px]">
                                        <div className={`hover:bg-[#FCE7AE] hover:bg-opacity-50 cursor-pointer flex w-full items-center justify-between ${selectedPage === 1 ? 'bg-[#FCE7AE]' : ''} px-[10px] py-[5px] rounded-md`} onClick={() => setSelectedPage(1)}>
                                            <div className="flex items-center gap-[7px] ">
                                                <LucideKey />
                                                <p className="text-black text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                                    {t('t155')}
                                                </p>
                                            </div>
                                            <MdArrowRight size={30} className="hidden xl:block mr-[30px] md:mr-[110px] lg:mr-[140px] xl:mr-[50px] cursor-pointer" />
                                        </div>
                                    </div>
                                    <div className="flex w-full items-center justify-between ">
                                        <div className="flex w-full items-center justify-between mt-[10px] pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px]">
                                            <div className={`hover:bg-[#FCE7AE] hover:bg-opacity-50 cursor-pointer flex w-full items-center justify-between px-[10px] py-[5px] rounded-md ${selectedPage === 2 ? 'bg-[#FCE7AE]' : ''}`} onClick={() => setSelectedPage(2)}>
                                                <div className="flex items-center gap-[7px]">
                                                    <MdHelp size={16} />
                                                    <p className="text-black text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                                        {t('t156')}
                                                    </p>
                                                </div>
                                                <MdArrowRight size={30} className="hidden xl:block mr-[30px] md:mr-[110px] lg:mr-[140px] xl:mr-[50px] cursor-pointer" />

                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex w-full items-center justify-between ">
                                        <div className="flex w-full items-center justify-between mt-[10px] pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px]">
                                            <div className={`hover:bg-[#FCE7AE] hover:bg-opacity-50 cursor-pointer flex w-full items-center justify-between px-[10px] py-[5px] rounded-md ${selectedPage === 3 ? 'bg-[#FCE7AE]' : ''}`} onClick={() => setSelectedPage(3)}>
                                                <div className="flex items-center gap-[7px]">
                                                    <MdLock size={16} />
                                                    <p className="text-black text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                                        {t('t157')}
                                                    </p>
                                                </div>
                                                <MdArrowRight size={30} className="hidden xl:block mr-[30px] md:mr-[110px] lg:mr-[140px] xl:mr-[50px] cursor-pointer" />

                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={() => handleClickOpen()} className="flex w-full items-center justify-between mt-[10px] cursor-pointer">
                                        <p className="hover:underline hover:decoration-red-500 text-[#ff2d00] pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[60px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px] text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                            {t('t158')}
                                        </p>
                                    </div>

                                    <div onClick={() => handleClickOpen2()} className="flex w-full items-center justify-between mt-[20px] cursor-pointer">
                                        <p className="hover:underline hover:decoration-red-500 text-[#ff2d00] pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[60px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px] text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                            {t('t159')}
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {
                            selectedPage === 0 &&
                            <div className=" ">
                                <ResearcherEditProfile t={t} />
                            </div>
                        }
                        {
                            selectedPage === 1 &&
                            <div className=" ">
                                <ResearcherChangePassword t={t} />
                            </div>
                        }
                        {
                            selectedPage === 3 &&
                            <div className=" ">
                                <ResearcherTerms t={t} />
                            </div>
                        }
                        {
                            selectedPage === 2 &&
                            <div className=" ">
                                <ResearcherHelp t={t} />
                            </div>
                        }
                    </div>
            }

            <Dialog
                open={openError}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseError(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {errorMsg}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm md:mr-[0px]"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className='flex flex-col justify-center items-center text-center'>
                            <div className='mt-[0px]'>{t('t160')}</div>
                            <div className="flex justify-center item-center gap-[20px] mt-[20px]">
                                <Button
                                    onClick={handleClose}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t145')}
                                </Button>
                                <Button
                                    onClick={() => { handleDeleteAccount() }}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t144')}
                                </Button>
                            </div>
                        </div>
                    </DialogContent>
                </DialogContent>
            </Dialog>

            <Dialog
                open={open2}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose2(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm md:mr-[0px]"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className='flex flex-col justify-center items-center text-center'>
                            <div className='mt-[0px]'>{t('t161')}</div>
                            <div className="flex justify-center item-center gap-[20px] mt-[20px]">
                                <Button
                                    onClick={handleClose2}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t145')}
                                </Button>
                                <Button
                                    onClick={() => {
                                        localStorage.clear();
                                        sessionStorage.clear();
                                        navigate('/loginas')
                                    }}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t144')}
                                </Button>
                            </div>
                        </div>
                    </DialogContent>
                </DialogContent>
            </Dialog>

        </div>
    )
}

export default ResearcherSettingsPageDesktop;
